import { useQuery } from '@tanstack/react-query';
import type { OrganizationResponse } from '../types/Organization';

export default function useFetchOrganization() {
  return useQuery({
    queryKey: ['organization'],
    queryFn: async () => {
      const response = await fetch('/agent/api/organization');
      const data: OrganizationResponse = await response.json();

      return data;
    },
  });
}
